import React from 'react';
const testimonials = [{
  initials: 'LG',
  name: 'Lucas G.',
  location: '📍 Buenos Aires | Ex Empleado de Comercio',
  quote: '"Compré un viernes a la noche. El sábado siguiente hice mi primer pulido con el protocolo del Tomo 2 y el cliente quedó en shock. Me pidió el sellado cerámico en el momento. Cobré $180.000 en un día. Nunca había ganado tanto en tan poco tiempo."'
}, {
  initials: 'MR',
  name: 'Martín R.',
  location: '📍 Córdoba | Detailer Independiente',
  quote: '"Llevaba 3 años lavando autos sin saber que los estaba rayando. Con el sistema de 3 baldes del Tomo 1 cambié todo. Ahora mis clientes me mandan fotos al sol y no hay un solo swirl mark. Eso solo me llenó la agenda de referidos."'
}, {
  initials: 'FA',
  name: 'Federico A.',
  location: '📍 Rosario | Dueño de Taller de Estética Automotriz',
  quote: '"El Tomo 5 de negocios me enseñó a presentar presupuestos como un consultor, no como un lavadero. Cerré mi primer Vidrio Líquido en $320.000 usando el script de WhatsApp del Bono 2. El cliente ni negoció el precio."'
}, {
  initials: 'JP',
  name: 'Joaquín P.',
  location: '📍 Mendoza | Detailer de Alta Gama',
  quote: '"El Método Cerámico™ me abrió un mundo. Antes le tenía miedo a los cerámicos por los High Spots. Con el protocolo de aplicación del Bono 1 hice mi primer trabajo de 9H sin un solo error. El cliente me mandó a 3 amigos esa misma semana."'
}, {
  initials: 'NC',
  name: 'Nicolás C.',
  location: '📍 Tucumán | Emprendedor del Detailing',
  quote: '"Nunca creí que desde el garage de mi casa podía cobrar como un taller premium. Después del Tomo 5 entendí que el problema era cómo me presentaba, no lo que hacía. En 30 días llené la agenda y duplicué mis precios sin perder un solo cliente."'
}, {
  initials: 'PR',
  name: 'Pablo R.',
  location: '📍 Santa Fe | Detailer + Empleado en Transición',
  quote: '"La Calculadora de Costos del Bono 3 me cambió la cabeza. Por primera vez sé exactamente cuánto gano por cada trabajo antes de arrancar. Dejé de regalar horas y empecé a cobrar lo que vale mi tiempo. Esto es diferente a todo lo que había visto."'
}, {
  initials: 'AG',
  name: 'Agustín G.',
  location: '📍 Salta | Detailer Principiante',
  quote: '"El Tomo 4 de química me salvó de gastar una fortuna en productos que no sirven. Aprendí a diluir correctamente y bajé mis costos de insumos a la mitad. Ahora gano más por trabajo gastando menos. El MegaPack se pagó solo en el primer cliente."'
}];
export function Testimonials() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#111111',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-295">
      <div className="mx-auto max-w-4xl" data-id="element-296">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center leading-10 text-white m-0 mb-2" data-id="element-297">
          Lo que dicen los que ya lo usan:
        </h2>
        <p className="text-center text-sm text-gray-400 m-0 mb-8" data-id="element-298">
          +1.240 detailers de todo el país ya profesionalizaron su técnica y su
          negocio con este sistema.
        </p>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-299">
          {testimonials.map((t, i) => <div key={i} className="rounded-xl p-5 shadow-sm border border-yellow-400/10 flex flex-col gap-3" style={{
          backgroundColor: 'rgba(255,255,255,0.03)'
        }} data-id="element-300">
              <div className="flex items-center gap-3" data-id="element-301">
                <div className="w-10 h-10 rounded-full bg-yellow-400 text-gray-900 flex items-center justify-center font-bold text-sm shrink-0" data-id="element-302">
                  {t.initials}
                </div>
                <div data-id="element-303">
                  <p className="font-bold text-white m-0 text-sm" data-id="element-304">{t.name}</p>
                  <p className="text-gray-500 m-0 text-xs" data-id="element-305">{t.location}</p>
                </div>
              </div>
              <p className="text-gray-300 m-0 text-sm italic leading-relaxed" data-id="element-306">
                {t.quote}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}